import type * as React from 'react';
const SvgIcoChatBubble = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.75 1.5C5.141 1.5 1.5 4.875 1.5 8.932c0 2.404 1.27 4.547 3.272 5.915a.75.75 0 0 1 .327.619v2.089l2.568-1.271.333.672.133-.738a9 9 0 0 0 1.617.146c4.609 0 8.25-3.375 8.25-7.432S14.359 1.5 9.75 1.5M8.115 17.736q.796.126 1.635.128c5.295 0 9.75-3.911 9.75-8.932S15.045 0 9.75 0 0 3.911 0 8.932c0 2.822 1.425 5.3 3.599 6.92v2.911a.75.75 0 0 0 1.083.672z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcoChatBubble;
